<template lang="pug">
.search-academy
  textbox-search.search-academy__action(v-model='academyNameValue', :placeholder='academyNamePlaceholder')
  textbox-search.search-academy__action(v-model='academyCodeValue', :placeholder='academyCodePlaceholder')
  button-search.search-academy__action(@click='searchEvent')
    slot(name='searchButtonText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TextboxSearch from '@/components/molecules/manager/TextboxSearch.vue'
import ButtonSearch from '@/components/molecules/manager/ButtonSearch.vue'

/**
 * 塾絞り込み
 */
@Component({
  components: {
    TextboxSearch,
    ButtonSearch,
  },
})
export default class SearchAcademy extends Vue {
  // 塾コード
  @Prop()
  academyCode!: string

  //  塾名
  @Prop()
  academyName!: string

  // 塾コードプレースホルダー
  @Prop()
  academyCodePlaceholder!: string

  // 塾名プレースホルダー
  @Prop()
  academyNamePlaceholder!: string

  // 塾コード変更時のイベント
  @Prop()
  academyCodeChangeEvent!: Function

  // 塾名変更時のイベント
  @Prop()
  academyNameChangeEvent!: Function

  // 検索イベント
  @Prop()
  searchEvent!: Function

  /*
   * 入力値ゲッター・セッター
   */
  // 塾コード
  get academyCodeValue(): string {
    return this.academyCode
  }
  set academyCodeValue(value: string) {
    this.academyCodeChangeEvent(value)
  }
  // 塾名
  get academyNameValue(): string {
    return this.academyName
  }
  set academyNameValue(value: string) {
    this.academyNameChangeEvent(value)
  }
}
</script>

<style lang="stylus" scoped>
.search-academy
  display flex

  &__action
    margin 7px 5px
</style>
